export default __webpack_public_path__ + "static/media/waterIc1.43e7a432.svg";